module.exports = __webpack_public_path__ + "img/banner3.b64e25af.jpg";